import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgView1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .a {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("title", { children: "view-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.5,12S5.25,4.5,12,4.5,22.5,12,22.5,12,18.75,19.5,12,19.5,1.5,12,1.5,12Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.25,12A2.25,2.25,0,0,1,9.75,12"
		})
	]
});
export default SvgView1;
